import { baseApi, API_TAGS, BaseQueryParams } from '@/shared/api';
import { createDashboardEndpointBuilder, type DashboardOptionsResponse } from '@/entities/dashboard';

const optionsEndpoint = createDashboardEndpointBuilder('/options');

export const optionsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getDashboardOptions: builder.query<DashboardOptionsResponse, BaseQueryParams>({
      query: (options) => ({
        url: optionsEndpoint(''),
        params: options
      }),
      providesTags: [API_TAGS.DASHBOARD, API_TAGS.OPTIONS]
    })
  })
});

export const { useGetDashboardOptionsQuery } = optionsApi;
